/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect, prevent, and address technical issues and security threats`)
};

const es_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar, prevenir y solucionar problemas técnicos y amenazas de seguridad`)
};

const de_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Probleme und Sicherheitsbedrohungen zu erkennen, zu verhindern und zu beheben`)
};

const nl_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische problemen en beveiligingsdreigingen te detecteren, voorkomen en aanpakken`)
};

const fr_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détecter, prévenir et résoudre les problèmes techniques et menaces de sécurité`)
};

const it_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevare, prevenire e affrontare problemi tecnici e minacce alla sicurezza`)
};

const pt_br2_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar, prevenir e solucionar problemas técnicos e ameaças de segurança`)
};

const pt_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detetar, prevenir e resolver problemas técnicos e ameaças de segurança`)
};

const ja_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術的問題およびセキュリティ脅威の検出、防止、対処`)
};

const zh_privacy_use_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测、预防和解决技术问题和安全威胁`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_6 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_6(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_6", locale)
	if (locale === "en") return en_privacy_use_6(inputs)
	if (locale === "es") return es_privacy_use_6(inputs)
	if (locale === "de") return de_privacy_use_6(inputs)
	if (locale === "nl") return nl_privacy_use_6(inputs)
	if (locale === "fr") return fr_privacy_use_6(inputs)
	if (locale === "it") return it_privacy_use_6(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_6(inputs)
	if (locale === "pt") return pt_privacy_use_6(inputs)
	if (locale === "ja") return ja_privacy_use_6(inputs)
	return zh_privacy_use_6(inputs)
};